import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vi from './locales/vi'
import zh from './locales/zh'

Vue.use(VueI18n)

const messages = {
  vi,
  zh
}

// Tự động phát hiện ngôn ngữ trình duyệt, ưu tiên localStorage, sau đó đến navigator.language
function detectLocale() {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale) return savedLocale;
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('vi')) return 'vi';
  if (browserLang.startsWith('zh')) return 'zh';
  return 'vi';
}

const locale = detectLocale();

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'vi', // Fallback về tiếng Việt nếu không tìm thấy bản dịch
  messages
})

export default i18n